export const IMAGES_CDN =
  "https://d2wxo3sy6usg49.cloudfront.net.fasterimage.io/img";
